import { ChangeDetectorRef, ContentChildren, Directive, inject, Input, QueryList } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { RequiredGroupMemberDirective } from './required-group-member.directive';

const requiredControlValidator: ValidatorFn = (control) => (control.value ? null : { requiredGroupMember: true });

@Directive({
  selector: '[ipSharedRequiredGroup]',
  standalone: true,
  providers: [{ provide: NG_VALIDATORS, useExisting: RequiredGroupValidator, multi: true }],
})
export class RequiredGroupValidator implements Validator {
  @Input('ipSharedRequiredGroup') validatorName: string | undefined;
  @ContentChildren(RequiredGroupMemberDirective, { descendants: true })
  children!: QueryList<RequiredGroupMemberDirective>;
  private cd = inject(ChangeDetectorRef);

  validate(): null | { requiredGroup: true } {
    console.log(this.children)
    const childrenControls = this.children
      .filter((member) => member.groupName === this.validatorName)
      .map((member) => member.model.control);
    const valid = childrenControls.find((childControl) => childControl.value);
    const dirty = childrenControls.find((childControl) => childControl.dirty);

    childrenControls.forEach((childControl) => {
      if (!valid) {
        childControl.addValidators(requiredControlValidator);
        dirty && childControl.markAsDirty({ onlySelf: true });
      } else {
        childControl.removeValidators(requiredControlValidator);
      }
      childControl.updateValueAndValidity({ onlySelf: true });
    });

    this.cd.detectChanges();
    return valid ? null : { requiredGroup: true };
  }
}
